<!-- 差旅信息 模块  订单填写 订单详情中-->
<template>
  <div class="travelInfo">
    <van-cell
      :title="isYlslh5 ? $t('D022','联系信息') : $t('F011','差旅信息')"
      :border="false"
      v-show="isShow"
    />

    <van-cell-group v-if="details==false">
      <!-- 成本中心 -->
      <van-field
        v-show="costCenter.show==1 && !isYlslh5"
        :label="$t('K001','成本中心')"
        is-link
        :readonly="true"
        :required="costCenter.must==1"
        v-model="travelInfo.costCenterName"
        :placeholder="$t('Choosing','请选择成本中心')"
        @click="openComponent('list','1')"
      />

      <!-- 项目 -->
      <van-field
        v-show="project.show==1"
        style="height: 100%;"
        type="textarea"
        autosize
        rows="1"
        :border="false"
        :label="$t('K002','项目')"
        :readonly="project.write!=1"
        :required="project.must==1"
        v-model="travelInfo.projectName"
        :placeholder="$t('Selection','请选择出差项目')"
        right-icon="arrow"
        @click-right-icon="openComponent('list','0')"
        @focus.prevent="changefocus"
      />
      <van-field
        label=" "
        style="padding-top:0px;"
        v-show="travelInfo.projectCode"
        v-model="travelInfo.projectCode"
      />
      <!-- 出差单号 -->
      <van-field
        v-show="travelNo.show==1"
        :label="$t('F017','出差单号')"
        :required="travelNo.must==1"
        :readonly="travelNo.write!=1"
        v-model="travelInfo.ccsqdNo"
        :placeholder="$t('K108','请输入出差单号')"
        right-icon="arrow"
        @click-right-icon="openComponent('list','4')"
        @focus.prevent="changefocus"
      />

      <!-- 科目码 -->
      <van-field
        v-show="subjectCode.show==1"
        :label="$t('F054','科目码')"
        :required="subjectCode.must==1"
        :readonly="subjectCode.write!=1"
        v-model="travelInfo.subjectCode"
        :placeholder="$t('xzkmm','请选择科目码')"
        right-icon="arrow"
        @click-right-icon="openComponent('list','2')"
        @focus.prevent="changefocus"
      />

      <!-- 违背事项 -->
      <van-field
        :label="$t('K325','违背事项')"
        readonly
        required
        v-show="travelInfo.violateItem"
        v-model="travelInfo.violateItem"
      />

      <!--违背原因 -->
      <!--      <van-field-->
      <!--        is-link-->
      <!--        :label="$t('K326','违背原因')"-->
      <!--        readonly-->
      <!--        required-->
      <!--        v-show="travelInfo.violateItem"-->
      <!--        v-model="travelInfo.reasonDesc"-->
      <!--        :placeholder="$t('K340','请选择违背原因')"-->
      <!--        @click="openComponent('violate')"-->
      <!--      />-->
      <van-field
        is-link
        :label="$t('K326','违背原因')"
        readonly
        required
        v-show="travelInfo.reasonCode"
        v-model="travelInfo.reasonDesc"
        :placeholder="$t('K340','请选择违背原因')"
        @click="openWbyy(violate)"
      />

      <!--出差备注  -->
      <van-field
        type="textarea"
        clearable
        autosize
        label="出差备注"
        :placeholder="remarks"
        v-show="travelRemarks.show==1"
        :required="travelRemarks.must==1"
        v-model="travelInfo.ccsqdRemark"
        @focus.prevent="changefocus"
      />
    </van-cell-group>

    <!--  -->
    <van-cell-group v-else-if="details">
      <van-field
        :label="$t('K001','成本中心')"
        :readonly="true"
        v-show="travelData.costCenterName && !isYlslh5"
        v-model="travelData.costCenterName"
      />
      <van-field
        :label="$t('K002','项目')"
        :readonly="true"
        v-show="travelData.projectName"
        v-model="travelData.projectName"
      />
      <van-field
        :label="$t('F017','出差单号')"
        :readonly="true"
        v-show="travelData.ccsqdNo"
        v-model="travelData.ccsqdNo"
      />
      <van-field
        :label="$t('F054','科目码')"
        :readonly="true"
        v-show="travelData.subjectCode"
        v-model="travelData.subjectCode"
      />
      <van-field
        :label="$t('K325','违背事项')"
        :readonly="true"
        v-show="travelData.violateitem"
        v-model="travelData.violateitem"
      />
      <van-field
        :label="$t('K326','违背原因')"
        :readonly="true"
        v-show="travelData.reasonDesc"
        v-model="travelData.reasonDesc"
      />
      <van-field
        label="出差备注"
        type="textarea"
        autosize
        readonly
        v-show="travelData.ccsqdRemark"
        v-model="travelData.ccsqdRemark"
      />
      <van-field
        :label="$t('D022','联系信息')"
        :readonly="true"
      >
        <div slot="input">
          {{ travelData.linkman || travelData.linkMan }} ({{ travelData.linkTel || travelData.linkMobile }})
          <div
            class="font12 gray"
            v-if="!isYlslh5"
          >
            <span v-if="travelData.linkEmail">{{ $t('D020', '邮箱') }} ({{ travelData.linkEmail }})</span>
          </div>
        </div>
      </van-field>
    </van-cell-group>
    <ld-check-list
      ref="list"
      :type="types"
      @selected="getInfo"
      :element="element"
    />

    <violate-list
      ref="violate"
      :cplx="cplx"
      :violate.sync="travelInfo"
      :element="element"
    />
  </div>
</template>

<script>

import ldCheckList from 'Components/ldCheckList'
import violateList from 'Components/violateList/index'
import {mapGetters} from 'vuex'

import {Field, Cell, CellGroup} from 'vant'
import {changefocus} from 'Utils/tools'
import defaultMixin from '@/business/mixins/default'

export default {
  name: 'TravelInfo',
  mixins: [defaultMixin],
  components: {
    ldCheckList,
    violateList,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  props: {
    details: {//是否详情页面
      type: Boolean,
      default: false
    },
    travelData: {//详情页面回显数据
      type: Object,
      default: function() {
        return {}
      }
    },
    cplx: {// 产品类型，请求对应违背列表
      type: String,
      default: '10901'
    },
    element:{
      type: String,
      default: ''
    },
  },
  data() {
    return {
      yc:true,
      isShow:false,
      types: '0',
      obj: {},
      costCenter: {},//成本中心信息
      project: {},//项目信息
      travelNo: {},//出差单信息
      travelRemarks: {},
      subjectCode: {},
      travelInfo: {},
      lvShow:false,//判断是否是龙旅
    }
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      tripType: 'tripType',
      userInfo: 'userInfo',
      pageCtrl: 'serviceCtrl',
    }),
    remarks(){
      if(this.lvShow){
        if(this.cplx == '10906'){ //用车文案
          return '多人乘车请备注乘车人及地址'
        }else if(this.pageCtrl.isShowCcsqd && this.tkSearchInfo.ccsqd && this.tkSearchInfo.cplx=='10901'){//机票文案特殊处理
          this.travelInfo.ccsqdRemark=this.tkSearchInfo.ccsqd.ccsy
          return
        }else{
          return '请填写出差备注'
        }
      }else{
        return '请填写出差备注'
      }
    }
  },
  created() {
    if(this.travelData.linkEmail == ''){
      this.yc = false
    }else{
      this.yc = true
    }
    this.isLvShow()
  },
  mounted() {
    if (this.details==false) {
      this.isShow=true
      this.getParameter()
      if(this.tripType==1&&this.userInfo.vipCorp.bookStyle==1){//出差单不获取默认成本中心
        this.getDefaultCostCenter()
      }
    }else{
      let arr=['costCenterName','projectName','ccsqdNo','subjectCode','violateitem','reasonDesc','ccsqdRemark']
      for(let k in arr){
        if(this.travelData[arr[k]]){
          this.isShow=true
          return
        }
      }
    }
  },
  methods: {
    changefocus,
    //参数初始化
    initParameter() {
      // 成本中心
      this.costCenter = {
        show: this.obj['20002'] || 0,
        must: this.obj['10995'] || 0,
        name: 'costCenterName'
      }
      //项目
      this.project = {
        show: this.obj['20003'] || 0,
        must: this.obj['10996'] || 0,
        write: this.obj['20005'] || 0,
        name: 'projectName'
      }
      //出差单号
      this.travelNo = {
        show: this.obj['20007'] || 0,//是否显示
        must: this.obj['20008'] || 0,//是否必填
        write: this.obj['20009'] || 0,//是否可以手输
        edit: this.obj['10999'] || 0,//是否可编辑
        name: 'ccsqdNo'
      }
      // 出差备注
      this.travelRemarks = {
        show: this.obj['20010'] || 0,
        must: this.obj['20011'] || 0,
        name: 'ccsqdRemark'
      }
      //科目码
      this.subjectCode = {
        show: this.obj['20012'] || 0,
        must: this.obj['20013'] || 0,
        write: this.obj['20014'] || 0,
        name: 'subjectCode'
      }
    },
    // 获取默认成本中心
    getDefaultCostCenter () {
      let params = {
        projectId: this.project.id,
        travelEmpId: this.userInfo.empInfo.empId,
        // txEmpIds: cxrids.toString()
      }
      this.$api['common/costCenterFindList'](params).then(res => {
        if (res.data.defaultCostCenter) {
          this.getInfo(res.data.defaultCostCenter)
        }
      })
    },
    getInfo(info) {//回调数据都放入 travelInfo对象中

      if (!this.$route.query.s) {
        const url = window.location.href
        var st = ''
        if (url.includes('tr/trEdit')) {
          var st1 = this.travelInfo
          if(this.$route.query.s){
            var st2 = JSON.parse(this.$route.query.s)
          }
          const obj = Object.assign(st1, st2)
          st = obj
        } else {
          st = this.travelInfo
        }
      }
      let cache = st
      Object.assign(cache, info,)
      cache.svalue && (cache.subjectCode = cache.svalue)//科目码字段转换
      if (info.projectCode && !this.costCenter.costCenterName) {// 选择项目如果没有选成本中心，再去获取一下默认成本中心
        this.getDefaultCostCenter()
      }
      this.travelInfo = ''
      this.travelInfo = cache
      console.log('cache', this.travelInfo)

    },
    openComponent(name, type) {//打开关闭组件
      this.types = type || '0'
      setTimeout(()=>{
        this.$refs[name].toggle()
      },20)
    },
    // 打开违背原因
    openWbyy() {
      this.types = '0'
      setTimeout(() => {
        this.$refs.violate.wbyy()
      }, 20)
    },
    getParameter() {
      //参数控制
      let arr = ['20002','10995','20003','10996','20005','20007','20008','20009','10999','20010','20011','20012','20013','20014']
      //20002 成本中心    0  不显示     1  显示   默认显示
      //10995 控制成本中心必填  0  不     1  可

      //20003 项目        0  不显示     1  显示   默认显示
      //10996 控制项目必填  0  不     1  可
      //20005 项目手输       0  不     1  可    默认可

      //20007 出差单号显示       0  不     1  可    默认可  签证不显示出差申请单
      if (this.cplx == $dict.PRO_TYPE.visa) {
        arr.splice(5, 3)
      }
      //20008 出差单号必填       0  不     1  可    默认可
      //20009 出差单号手输入       0  不     1  可    默认可
      //10999 控制出差申请单管控模式  即  出差申请单可以修改   默认0     1.管控    0 不管控

      //20010 出差备注显示       0  不     1  可    默认可
      //20011 出差备注必填       0  不     1  可    默认可

      //20012 科目码是否显示
      //20013 科目码是否必填
      //20014 科目码是否支持手输

      this.$api['common/queryParameter']({
        paramNos: arr.join(',')
      }).then(res => {
        let cache = res.data || {}
        let self = this
        if (cache.parameterResponses && cache.parameterResponses.length > 0) {
          cache.parameterResponses.forEach(item => {
            self.obj[item.paramNo] = item.value1
          })
        }
        this.initParameter()
      }).catch(res => {
        let cache = res.data || {}
        if (cache.parameterResponses && cache.parameterResponses.length > 0) {
          cache.parameterResponses.forEach(item => {
            this.obj[item.paramNo] = item.value1
          })
        }
      })
    },
    result() {
      if(this.tripType==2){
        return true
      }else{
        let arr = [
          this.costCenter,
          this.project,
          this.travelNo,
          this.travelRemarks,
          this.subjectCode
        ]
        let bl = arr.some(item => {
          if (!this.valid(item)) {
            return true
          }
        })
        //传值
        if (bl) {
          return false
        } else {
          this.$emit('selected', this.travelInfo)
          return this.travelInfo
        }
      }
    },
    valid(obj) {
      //验证 必填项 非空
      let cache = {
        costCenterName: '成本中心为必填项',
        projectName: '项目为必填项',
        ccsqdNo: '出差单号为必填项',
        ccsqdRemark: '出差备注为必填项',
        subjectCode: '科目码为必填项'
      }
      if (obj.must == 1) {
        if (!this.travelInfo[obj.name]) {
          this.$toast(cache[obj.name])
          return false
        }
      }
      return true
    },
    //对龙旅特殊处理
    isLvShow() {
      let temp = window.location.href;
      if (temp.includes("app.88882222.cn")) {
        this.lvShow = true;
      } else {
        this.lvShow = false;
      }
    },

  }
}
</script>

<style scoped lang="less">
</style>
